import Collapse from './Collapse';
export default Collapse;


//////////////////
// WEBPACK FOOTER
// ../~/antd/es/collapse/index.js
// module id = 732
// module chunks = 0